import { memo } from "react";
import Rating from "react-rating";
import styles from "../hotel.module.css";
import starColor from '../../icons/star-color.svg';
import starTransparent from '../../icons/star-transparent.svg';
import Button from "../../components/button/button";
import mail from "../hotel_imgs/Email.png";
import phone from "../hotel_imgs/phone.png";
import locationIcon from "../hotel_imgs/icon.png";
import media from "../hotel_imgs/internet.png";
import arrowIcon from '../../icons/arrow.svg'
import webSiteIcon from '../../icons/webSite.svg'
import MapHotels from '../../components/Google map/GoogleMap'

export default memo(function HotelPageHeader({ hotel, reviews }) {
    const isGooglePlace = hotel?.source === "google";
    const latitude = Number(hotel?.latitude);
    const longitude = Number(hotel?.longitude);
    const hasCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);
    const hotelRoute = isGooglePlace ? `/hotelreview?googlePlaceId=${hotel.placeId}` : `/hotelreview?hotelID=${hotel.id}`;
    const containerClassName = [
        styles.container,
        !hotel?.description ? styles.containerNoDescription : "",
    ].filter(Boolean).join(" ");

    return (
        <>
            <div className={styles.background}>
                <div className={containerClassName}>
                    <div className={styles.nameHotel}>
                        <div className={styles.section1}>
                            {hotel?.img && <div className={styles.firstPart}> <img alt="nameHotelImg" className={styles.nameHotelImg} src={hotel?.img} /></div>}
                            <div className={styles.section2}>
                                <p className={styles.hotelName}>{hotel?.name}</p>
                                {isGooglePlace && (
                                    <p className={styles.googleAttribution}>
                                        Hotel data from <a href={hotel.googleMapsUri || "#"} rel="noopener noreferrer" target="_blank" translate="no">Google Maps</a>
                                    </p>
                                )}
                                <div className={styles.rankingBlock}>
                                    <div className={styles.rank}>
                                        <p >{hotel?.overall_rating || 0}</p>
                                    </div>
                                    <Rating
                                        initialRating={hotel?.overall_rating / 2 || 0}
                                        stop={5}
                                        emptySymbol={<img src={starTransparent} className={styles.starIcon} alt='' />}
                                        fullSymbol={<img src={starColor} className={styles.starIcon} alt='' />}
                                        readonly
                                    />
                                    <p>( {reviews || 0} Reviews )</p>
                                </div>
                            </div>
                        </div>
                        <Button children='Book a hotel on Expedia' id={styles.bookBtn} onClick={() => window.open("https://expedia.com/affiliate/be2RLuN", "_blank")} />
                    </div>
                    <div className={styles.locationAbout}>
                        {hotel?.description && <div className={styles.aboutHotel} >
                            {hotel?.description &&
                                <>
                                    <h1 className={styles.title}>About the Hotel</h1>
                                    <p> {hotel.description}</p>
                                </>
                            }
                        </div>}
                        <div className={`${styles.location} ${!hotel?.description ? styles.locationFull : ""}`}>
                            <p className={styles.conatctInfo}>Contact Information</p>
                            <div className={styles.mediaContainer}>
                                <img alt="Social link" src={media} className={styles.icons} />
                                <a href={"https://expedia.com/affiliate/be2RLuN"} style={{ display: "flex" }} rel="noopener noreferrer" target="_blank">{hotel.name}  <img src={arrowIcon} alt="arrow" style={{ marginLeft: '5px' }} /></a>
                            </div>
                            {isGooglePlace && hotel?.googleMapsUri && <div className={styles.webContainer}>
                                <img alt="Google Maps" src={locationIcon} className={styles.icons} />
                                <a href={hotel.googleMapsUri} style={{ display: "flex" }} rel="noopener noreferrer" target="_blank" translate="no">View on Google Maps</a>
                            </div>}
                            {hotel['social-link'] && <div className={styles.webContainer}>
                                <img alt="Web Site" src={webSiteIcon} className={styles.icons} style={{width:"36px" , height:"37px" , opacity:"0.7" , padding:"7px"}}/>
                                <a href={hotel['social-link']} style={{ display: "flex" }} rel="noopener noreferrer" target="_blank">{hotel['social-link']} </a>
                            </div>}
                            {hotel?.email && <div className={styles.mailContainer}>
                                <img alt="mail" src={mail} className={styles.icons} />
                                <a href={`mailto:${hotel?.email}`} >{hotel.email}</a>
                            </div>}
                            {hotel?.phone && <div className={styles.phoneContainer}>
                                <img alt="phone" src={phone} className={styles.icons} />
                                <a href={`tel:${hotel?.phone}`} >{hotel.phone}</a>
                            </div>}
                            <div className={styles.locationContainer}>
                                <img alt="location" src={locationIcon} className={styles.icons} />
                                <p>{hotel?.location}</p>
                            </div>
                            {hasCoordinates && <div className={styles.mapContainer}>
                                <MapHotels center={{ lat: latitude + 0.004, lng: longitude }}
                                    zoom={14}
                                    containerStyleCustom={{ width: "100%", height: "200px" }}
                                    label={' '}
                                    locations={[{ id: hotel?.id || hotel?.placeId, route: hotelRoute, label: "A1", name: hotel?.name, rating: hotel?.overall_rating || false, position: { lat: latitude, lng: longitude } }]}
                                />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
})
